import React, { Component } from "react";

import "./css/InverterSelectorForm.css";

export class ProgressSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNextButton: false,
    };
    //this.props.showNextButton(false)
  }

  render() {
    return (
      //App starts here
      <>
        <div className="ps-container">
          <div
            className="ps-item-container"
          >
            <img
              src={
                this.props.data.userOPdata[this.props.data.modelIndex][
                  "Image URL"
                ]
              }
              
              style={{
                maxWidth: "300px",
                maxHeight: "300px",
                width: "auto",
                height: "auto",
                minWidth: "auto", // If you still want to ensure a minimum width
              }}
            />

            <div className="Card" style={{ width: "100%" , alignItems: "center" }}>
              <h1 style={{ fontSize: "xx-large" }} className="infoText">
                {this.props.data.userOPdata[this.props.data.modelIndex]["Name"]}
              </h1>
              <div className="infoText">
                <b>Recommended Capacity: </b>
                {
                  this.props.data.userOPdata[this.props.data.modelIndex][
                    "Power Rating"
                  ]
                }{" "}
                W
              </div>
              <div className="infoText">
                <b>Required Capacity: </b>
                {this.props.data.totalcap} W
              </div>
              <div className="infoText">
                <b>Input: </b>
                {this.props.data.ivData}
              </div>
              <div className="infoText">
                <b>Output: </b>
                {this.props.data.ovData}
              </div>
              <div className="infoText">
                <b>Enclosure: </b>
                {this.props.data.cabType}
              </div>
              <div className="infoText">
                <b>Max number of Aux breakers: </b>
                {
                  this.props.data.userOPdata[this.props.data.modelIndex][
                    "Aux Circuit Breakers"
                  ]
                }
              </div>
            </div>
          </div>
        </div>

        {
          /** Clean Code*/

          <div className="PS-Header-Container">
            <div className="PS-Header-Box">
              <div className="PS-img-box">
                {/*** add Image here  */}

                <img
                  id="prodimg"
                  src={
                    this.props.data.userOPdata[this.props.data.modelIndex][
                      "Image URL"
                    ]
                  }
                  style={{ width: "40%", minWidth: "250px" }}
                  alt=""
                />
              </div>

              <div className="PS-text-box">
                <h1 style={{ fontSize: "xx-large" }} className="infoText">
                  {this.props.data.productType}
                </h1>
                <div className="infoText">
                  <b>Capacity: </b>
                  {
                    this.props.data.userOPdata[this.props.data.modelIndex][
                      "Power Rating"
                    ]
                  }
                  W
                </div>
                <div className="infoText">
                  <b>Required Capacity: </b>
                  {this.props.data.totalcap} W
                </div>
                <div className="infoText">
                  <b>Input: </b>
                  {this.props.data.ivData}
                </div>
                <div className="infoText">
                  <b>Output: </b>
                  {this.props.data.ovData}
                </div>
                <div className="infoText">
                  <b>Enclosure: </b>
                  {this.props.data.cabType}
                </div>
                <div className="infoText">
                  <b>Max number of Aux breakers: </b>
                  {
                    this.props.data.userOPdata[this.props.data.modelIndex][
                      "Aux Circuit Breakers"
                    ]
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
  }
}

export default ProgressSteps;
